import {FETCH_HOMEPAGE} from '../actions/actionTypes';

const INITIAL_STATE = { instagram: [], inspiration: null };

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_HOMEPAGE + '_FULFILLED':
            return {
                ...state,
                instagram: action.payload.data.instagram,
                inspiration: action.payload.data.inspiration
            };

        default:
            return state;
    }
}
